import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';

import { EntryList } from '../shared/entry-list.component';

import { Entry } from '../shared/entry.model';

import { WaldayuInfo } from '../../app/global';

// import { WaldayuService } from '../../app/waldayu.service'

@Component({
  selector: 'page-search',
  templateUrl: 'search.html'
})
export class Search {
  entries: Entry[] = WaldayuInfo.allEntries;
  matches: Entry[];
  partMatches: Entry[];
  maybeMatches: Entry[];
  searchQuery: string = '';

  constructor(public navCtrl: NavController) {
  }

  getEnglish() {
    var results = []
    var re = new RegExp(this.searchQuery, 'i')
    for (let entry of this.entries) {
      if (re.test(entry.definition[0])) {
        results.push(entry)
      }
    }
    let sorted_answers = results.sort(function (a, b) {
      return a["displayDefinition"][0].length - b["displayDefinition"][0].length;
    });
    return (sorted_answers.slice(0, 9))
  };

  // Get English and target results
  getResults() {
    if (this.searchQuery.length > 1) {
      let english = this.getEnglish();
      let target = window["searchGit"](this.searchQuery)
      let matches = [];
      let partMatches = [];
      let maybeMatches = [];
      var populateEng = function () {
        for (let result of english) {
          var entry = result
          entry.type = "eng";
          matches.push(entry);
        }
      }

      var populateTarget = function () {
        for (let result of target) {
          var entry = result[1]
          if (entry.distance === 0) {
            entry.type = "git";
            matches.push(entry);
          }

          if (entry.distance <= 1 && entry.distance > 0) {
            entry.type = "git";
            partMatches.push(entry);
          }

          if (entry.distance <= 2 && entry.distance > 1) {
            entry.type = "git";
            maybeMatches.push(entry);
          }
        }
      }
      
      populateEng();
      populateTarget();
      this.matches = matches;
      this.partMatches = partMatches;
      this.maybeMatches = maybeMatches;
    }
  };

}



// WEBPACK FOOTER //
// ./src/pages/search/search.ts